export default {
  tokenExpired: 'Please login again',
  // Upload.vue
  uploadingTips: '请先等待所有文件上传完成！',
  uploadOkTips: '文件上传完成',
  uploadErrorTips: '文件上传失败！',
  notFormatTips: '文件 {0} 不支持该文件格式！',
  maxSizeTips: '文件 {0} 体积超出规定大小，请先压缩后再上传！',

  setMainImageBtn: '设为主图',
  clickPreview: '点击放大',
  defaultUploadBtn: '点击上传',
  ask: '您确认这样操作吗?',
  confirm: '确认',
  cancel: '取消',
  success: '成功',
  whiteImageBjMsg: '请选择纯白底色图片',
  imageRequirements: '图片要求：宽高相等且小于 1 Mb。最多可上传10张图片，拖拽可调节顺序。'
}
